import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.5625 2.15535V4.86602C12.5625 5.23355 12.5625 5.41732 12.634 5.5577C12.6969 5.68118 12.7973 5.78157 12.9208 5.84449C13.0612 5.91602 13.245 5.91602 13.6125 5.91602H16.3232M16.5 7.22079V11.9535C16.5 13.0561 16.5 13.6074 16.2854 14.0286C16.0967 14.399 15.7955 14.7002 15.425 14.8889C15.0039 15.1035 14.4526 15.1035 13.35 15.1035H9.15C8.0474 15.1035 7.49609 15.1035 7.07496 14.8889C6.70451 14.7002 6.40333 14.399 6.21458 14.0286C6 13.6074 6 13.0561 6 11.9535V5.12852C6 4.02591 6 3.47461 6.21458 3.05347C6.40333 2.68303 6.70451 2.38185 7.07496 2.1931C7.49609 1.97852 8.0474 1.97852 9.15 1.97852H11.2577C11.7393 1.97852 11.98 1.97852 12.2066 2.03291C12.4075 2.08114 12.5995 2.16069 12.7757 2.26863C12.9744 2.39038 13.1446 2.56063 13.4851 2.90113L15.5774 4.9934C15.9179 5.3339 16.0881 5.50415 16.2099 5.70283C16.3178 5.87898 16.3974 6.07102 16.4456 6.2719C16.5 6.49848 16.5 6.73925 16.5 7.22079Z",
		stroke: "currentColor",
		strokeWidth: 1.67,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.6558 17.6532C12.2182 17.8699 11.6455 17.8699 10.4999 17.8699H6.13625C4.99069 17.8699 4.41791 17.8699 3.98036 17.6532C3.59549 17.4625 3.28257 17.1583 3.08647 16.7841C2.86353 16.3587 2.86353 15.8019 2.86353 14.6881V7.79417C2.86353 6.68043 2.86353 6.12356 3.08647 5.69817C3.28257 5.32398 3.59549 5.01976 3.98036 4.8291",
		stroke: "currentColor",
		strokeWidth: 1.67,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgDocumentsIcon;
